export const colorsJenks = [
  '#f6eff7',
  '#bdc9e1',
  '#74a9cf',
  '#2b8cbe',
  '#045a8d'
];


export const colorsChange = [
  '#b35806',
  '#f1a340',
  '#fee0b6',
  '#d8daeb',
  '#998ec3',
  '#542788'
];

/*
export const colorsChange = [
  '#d73027',
  '#f46d43',
  '#fdae61',
  '#d9ef8b',
  '#91cf60',
  '#1a9850'
];*/


export const colorsChangeReverse = [
  '#1a9850',
  '#91cf60',
  '#d9ef8b',
  '#fdae61',
  '#f46d43',
  '#d73027'
];